/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

class FeaturedShowItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: '',
      day: '',
    };
  }

  componentDidMount() {
    this.getEventDay();
    this.getEventMonth();
  }

  getEventDay() {
    const { showData } = this.props;
    const eventDate = new Date(showData.start_date);
    const day = eventDate.getDate();
    let selector;

    if (day <= 0) {
      selector = 4;
    } else if ((day > 3 && day < 21) || day % 10 > 3) {
      selector = 0;
    } else {
      selector = day % 10;
    }

    this.setState({
      day: day + ['th', 'st', 'nd', 'rd', ''][selector],
    });
  }

  getEventMonth() {
    const { showData } = this.props;

    const eventDate = new Date(showData.start_date);
    const month = eventDate.toLocaleString('en-us', { month: 'long' });

    this.setState({
      month,
    });
  }

  render() {
    const { goToSignUp, showData } = this.props;
    const { month, day } = this.state;
    const { name, logo, primary_color, id } = showData;

    let shortName;

    if (id === 1853) {
      shortName = 'luxury';
    } else if (id === 1855) {
      shortName = 'romance';
    }

    return (
      <React.Fragment>
        <div className="headerItem__date">
          {/* {id === 1403 && ( */}

          <div className="headerItem__date--month">{month}</div>
          <div className="headerItem__date--day">{day}</div>
          {/* )} */}

          {/* {id !== 1403 && (
            <div className="headerItem__date--onDemand">
              On-demand
            </div>
          )} */}
        </div>
        <div className="headerItem__info">
          <div className="headerItem__info--text">
            <img height="70" src={logo} alt={name} />
            <button
              type="button"
              className="btn btn-outline"
              onClick={() => goToSignUp(shortName)}
              style={{ borderColor: primary_color, color: primary_color }}
            >
              {/* {i18n.translate('homeView.buttons.signUp')} */}
              {'Sign up'}
            </button>
          </div>
          <div className="headerItem__info--border" style={{ backgroundColor: primary_color }} />
        </div>
      </React.Fragment>
    );
  }
}

export default FeaturedShowItem;

FeaturedShowItem.propTypes = {
  showData: PropTypes.shape().isRequired,
  goToSignUp: PropTypes.func.isRequired,
};
